import { render, staticRenderFns } from "./DeleteAccountStepTow.vue?vue&type=template&id=6b537064&scoped=true"
import script from "./DeleteAccountStepTow.vue?vue&type=script&lang=js"
export * from "./DeleteAccountStepTow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b537064",
  null
  
)

export default component.exports